'use strict';

/**
 * Collection of scripts related with the store selector component.
 */
var storeSelector = {};

// Constants
var ATTR = {
    DATA: {
        URL: 'data-url'
    },
    DISABLED: 'disabled',
    URL: 'url'
};
var SELECTOR = {
    SELECT: 'select#header-store-selector, select#header-store-selector-mobile'
};

/**
 * Collection of onChange event listeners.
 */
var onChange = {
    /**
     * Attach an event listener to the store selector select element that triggers on selected value change.
     * If the value is changed, a new store is contextualized.
     */
    selectedValue: function () {
        $('body').on('change', SELECTOR.SELECT, function () {
            // Constants
            const $THIS = $(this);
            const NEW_VALUE = $THIS.val();
            const URL = $THIS.data(ATTR.URL);
            const SELECT_MOBILE = $.comCustom().getSelect('header-store-selector-mobile');
            const SELECT_DESKTOP = $.comCustom().getSelect('header-store-selector');

            if (URL) {
                SELECT_MOBILE.$select2.prop('disabled', true);
                SELECT_DESKTOP.$select2.prop('disabled', true);

                $.spinner().start();
                $.ajax({
                    method: 'POST',
                    url: URL,
                    data: { sid: NEW_VALUE },
                    success: function (response) {
                        if (response && 'success' in response && response.success) {
                            $THIS.attr(ATTR.DISABLED, 'true');

                            if ('showReviewCartModal' in response && response.showReviewCartModal) {
                                $.spinner().stop();
                                $('body').trigger('com:modal.show.reviewCart');
                            } else if ('redirectURL' in response && typeof response.redirectURL === 'string') {
                                window.location.href = response.redirectURL;
                            }
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    }
};

/**
 * Attach every event listener related with the store selector to the DOM.
 */
function attachEventListeners() {
    onChange.selectedValue();
}

// Expose functions
storeSelector.attachEventListeners = attachEventListeners;

module.exports = storeSelector;
